import { SvgIcon } from "@/svg";
import { Link, useLocation } from "react-router";
import clsx from "clsx";

export type LogoutButtonProps = {
  preset?: "bordered" | "simple";
  className?: string;
} & React.PropsWithChildren;

export function LogoutButton({ preset = "simple", className }: LogoutButtonProps) {
  const location = useLocation();

  return (
    <Link
      to={`${location.pathname}?logout`}
      className={clsx(
        "flex items-center gap-4 text-sm hover:bg-pureWhite text-sematicRed py-2 px-4 rounded-lg",
        preset === "bordered" && "border border-sematicRed",
        className,
      )}
    >
      <SvgIcon icon="Logout" />
      Logout
    </Link>
  );
}
